import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import { useEffect } from 'react';
import styles from './index.module.scss';

export default function H5() {
    const { t } = useLang('theProduct.Animation1');
    const { t: t1 } = useLang('theProduct.Animation1.screen1');
    const { t: t2 } = useLang('theProduct.Animation1.screen2');
    const { locale = 'us' } = getLocal();
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const mask1 = document.querySelector('.mask1');
                const screen1 = document.querySelector('.screen1');
                const screen2 = document.querySelector('.screen2');
                const screen3 = document.querySelector('.screen3');
                const screen4 = document.querySelector('.screen4');
                const scrren5 = document.querySelector('.screen5');
                const ani = AniContainer.create({
                    triggerElement: `.${styles.comp}`,
                    triggerHook: 0,
                    offset: 0,
                    duration: '700%',
                    onEnter: () => {},
                    onLeave: () => {},
                    asyncTimeLine: [1.4, 2.4, 2.4, 5, 5, 5, 7],
                    asyncFromTo: [
                        [mask1, { opacity: 0 }, { opacity: 1 }, 1],
                        [screen1, { opacity: 1 }, { opacity: 0 }, 0.1],
                        [screen2, { opacity: 1 }, { opacity: 0 }, 0.1],
                        [screen3, { opacity: 1 }, { opacity: 0 }, 0.4],
                        [screen4, { opacity: 1 }, { opacity: 0 }, 0.4],
                        [scrren5, { opacity: 0 }, { opacity: 1 }, 0.4],
                        [scrren5, { opacity: 0 }, { opacity: 1 }, 0],
                    ],
                });

                return () => {
                    if (ani) AniContainer.removeScene(ani);
                };
            }, 100);
        }
    }, []);
    return (
        <div className={`${styles.comp} GtmModuleData-section`} id="wave3-D" data-section-id="wave3-D" data-section-title="Unmatched Cooling and Heating">
            <div className="screen1 range2">
                <EcoSection
                    label={t1('label')}
                    title={t1('title')}
                    desc={t1.rich('desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    })}
                />
                <div className="screen-b-img">
                    <div className="wd1">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775548/wd1.svg" loading="lazy" alt="" />
                        <div className="text1">{t('wd1')}</div>
                    </div>
                    <EcoImg className="screen-b-img" pc="https://websiteoss.ecoflow.com/upload/image/1744339902864/D1-1-h5.jpg" />
                </div>
            </div>
            <div className="screen2">
                <div className="mask1"></div>
                <EcoImg className="screen-b-img" pc="https://websiteoss.ecoflow.com/upload/image/1744881392069/1-h5.jpg" />
            </div>
            <div className="screen3">
                <EcoSection
                    label={t2('label')}
                    title={t2('title')}
                    desc={t2.rich('desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    })}
                />
                <div className="screen-b-img">
                    <div className="wd2">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775716/wd2.svg" loading="lazy" alt="" />
                        <div className="text2">{t('wd2')}</div>
                    </div>
                    <EcoImg className="screen-b-img" pc="https://websiteoss.ecoflow.com/upload/image/1744339903308/D2-1-h5.jpg" />
                </div>
            </div>
            <div className="screen4">
                <EcoImg className="screen-b-img" pc="https://websiteoss.ecoflow.com/upload/image/1744881392427/2-h5.jpg" />
            </div>
            <div className="screen5 range3" id="screen3">
                <EcoSectionCard
                    theme="black"
                    layout="center-center"
                    isVideo={true}
                    title={t('screen3')}
                    poster="https://websiteoss.ecoflow.com/upload/image/1744880265179/%E8%A7%86%E9%A2%911.jpg"
                    pc="https://websiteoss.ecoflow.com/upload/video/1744880135071/video1.mp4"
                />
            </div>
        </div>
    );
}
